import { render } from "./button.vue?vue&type=template&id=62a478a7"
const script = {}
script.render = render

export default script